import { useMemo, useState, type ReactNode } from 'react'
import { UiStateContext } from '@/hooks/use-ui-state'

export function UiStateProvider({ children }: { children: ReactNode }) {
  const [paletteOpen, setPaletteOpen] = useState(false)
  const [newIssueOpen, setNewIssueOpen] = useState(false)
  const [sheetIssue, setSheetIssue] = useState<number | null>(null)

  const value = useMemo(
    () => ({ paletteOpen, setPaletteOpen, newIssueOpen, setNewIssueOpen, sheetIssue, setSheetIssue }),
    [paletteOpen, newIssueOpen, sheetIssue],
  )

  return <UiStateContext.Provider value={value}>{children}</UiStateContext.Provider>
}
